export const userPermission = {
    userView: "user.view",
    userCreate: "user.create",
    userDelete: "user.delete",
    userUpdate: "user.update"
};
